import {FlowchartValidator} from '../platform/FlowchartValidator';
import {
  FlowchartValidationErrorType,
  MaybeValidationError,
  ProcessFlowchartErrorType,
  ProcessFlowchartValidationError,
} from './ProcessFlowchartForValidationTypes';

/**
 * Checks if an error type is a ProcessFlowchartErrorType (platform-generated error)
 * that can be overridden, as opposed to an application-specific error type.
 */
function isProcessFlowchartErrorType(
  errorType: FlowchartValidationErrorType
): errorType is ProcessFlowchartErrorType {
  return Object.values(ProcessFlowchartErrorType).includes(errorType as ProcessFlowchartErrorType);
}

export const pushErrors = (
  errors: Array<ProcessFlowchartValidationError>,
  errorOrErrors: MaybeValidationError | Array<ProcessFlowchartValidationError> | null,
  validator?: FlowchartValidator
): Array<ProcessFlowchartValidationError> => {
  let newErrors = [...errors];
  if (errorOrErrors != null) {
    if (Array.isArray(errorOrErrors)) {
      for (const error of errorOrErrors) {
        newErrors = pushErrors(newErrors, error, validator);
      }
    } else {
      // Application-specific validators support overriding the error message for platform-generated errors.
      const overrideMessage =
        validator && isProcessFlowchartErrorType(errorOrErrors.errorType)
          ? validator.errorTypeToMessageOverride[errorOrErrors.errorType]
          : undefined;
      newErrors = [
        ...newErrors,
        {
          ...errorOrErrors,
          errorMessage: overrideMessage ?? errorOrErrors.errorMessage,
        },
      ];
    }
  }
  return newErrors;
};
